import { PureComponent, cloneElement, createElement } from 'react';
import { c as _defineProperty, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { defaultProps } from './defaultSettings.js';

/** function to get default styles for innerWrapper */
const innerStyle = ({
  translate,
  dragging,
  mounted,
  transition,
  inertiaScrolling
}) => {
  return {
    transform: `translate3d(${translate}px, 0px, 0px)`,
    transition: `transform ${dragging || !mounted ? '0' : transition}s${inertiaScrolling ? ' ease-out' : ''}`
  };
};

// ** innerWrapper component, menuItems will be children */
class InnerWrapper extends PureComponent {
  constructor(...args) {
    super(...args);
    /** set ref of this component */
    _defineProperty(this, "setMenuInnerRef", value => {
      const {
        setMenuInnerRef
      } = this.props;
      setMenuInnerRef({
        menuInner: {
          key: 'menuInner',
          elem: value
        }
      });
    });
    /** set ref for menuItems */
    _defineProperty(this, "setRef", (key, elKey, index, value) => {
      const {
        setRef
      } = this.props;
      setRef({
        [key]: {
          index,
          key: elKey,
          elem: value
        }
      });
    });
    /** check if menuItem active */
    _defineProperty(this, "isElementActive", (itemId, selected) => String(itemId) === String(selected));
    /** make array of menuItems */
    _defineProperty(this, "setItems", (arr, selected) => {
      return arr.map(el => {
        const {
          onClick = () => false
        } = el.props;
        const props = {
          onClick: () => this.forwardClickHandler(el.key, onClick),
          selected: this.isElementActive(el.key, selected)
        };
        return /*#__PURE__*/cloneElement(el, props);
      });
    });
    _defineProperty(this, "forwardClickHandler", (key, onClick = () => false) => () => {
      const {
        onClick: selectItem
      } = this.props;
      onClick();
      selectItem(key);
    });
  }
  render() {
    const {
      translate,
      dragging,
      mounted,
      transition,
      innerWrapperStyle,
      innerWrapperClass,
      itemStyle,
      itemClass,
      itemClassActive,
      data,
      selected,
      inertiaScrolling
    } = this.props;
    const items = this.setItems(data, selected);
    const style = innerStyle({
      dragging,
      inertiaScrolling,
      mounted,
      transition,
      translate
    });
    const wrapperStyles = _objectSpread2(_objectSpread2({}, style), innerWrapperStyle);
    return /*#__PURE__*/createElement("div", {
      className: innerWrapperClass,
      style: wrapperStyles,
      ref: inst => this.setMenuInnerRef(inst)
    }, items.map((Item, i) => /*#__PURE__*/createElement("div", {
      ref: inst => this.setRef(`menuitem-${i}`, String(Item.key || ''), i, inst),
      className: `${itemClass} ${Item.props.selected ? itemClassActive : ''}`,
      key: `menuItem-${Item.key}`,
      style: itemStyle,
      onClick: Item.props.onClick(),
      tabIndex: 0,
      role: "button"
    }, Item)));
  }
}
_defineProperty(InnerWrapper, "defaultProps", {
  data: [],
  dragging: true,
  mounted: false,
  selected: defaultProps.selected,
  transition: defaultProps.transition,
  translate: defaultProps.translate
});

export default InnerWrapper;
export { innerStyle };
